module.exports = {"header":{"title":"Become a Partner","subTitle":"HRdownloads is actively building our network of mutually beneficial partnerships. Our goal is to always develop programs that meet both parties' objectives of adding value to an audience <span class='no-break-text'>that we share.</span>"}}


//////////////////
// WEBPACK FOOTER
// ./src/translations/en/become-partner.json
// module id = 3gvT
// module chunks = 0